import { Phone, Mail } from "lucide-react";
import { CONTACT } from "../data/site";

export const StickyContact = () => (
    <div
        className="fixed bottom-0 inset-x-0 z-40 bg-black/90 backdrop-blur-md border-t border-[#E53E3E]/40"
        data-testid="sticky-contact-bar"
    >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
            <a
                href={CONTACT.phoneHref}
                data-testid="sticky-phone-link"
                className="flex items-center gap-2.5 text-white hover:text-[#E53E3E] transition-colors duration-300 group"
            >
                <span className="flex items-center justify-center w-9 h-9 bg-[#E53E3E] group-hover:bg-[#c93636] transition-colors duration-300">
                    <Phone size={16} />
                </span>
                <span className="font-mono-xp text-xs sm:text-sm tracking-wider">{CONTACT.phone}</span>
            </a>
            <span className="hidden md:block font-mono-xp text-[10px] uppercase tracking-[0.3em] text-gray-500">24/7 Scotland Command Centre</span>
            <a
                href={CONTACT.emailHref}
                data-testid="sticky-email-link"
                className="flex items-center gap-2.5 text-white hover:text-[#E53E3E] transition-colors duration-300 group"
            >
                <span className="hidden sm:block font-mono-xp text-xs sm:text-sm tracking-wider">{CONTACT.email}</span>
                <span className="flex items-center justify-center w-9 h-9 bg-[#E53E3E] group-hover:bg-[#c93636] transition-colors duration-300">
                    <Mail size={16} />
                </span>
            </a>
        </div>
    </div>
);
